import { ComponentType } from "react";

/**
 * Higher order component that automatically resolves your prop interface your default props.
 * This is helpful when:
 *      You have an "optional" property in your component's prop interface.     ex. myOptional?: string
 *      You define some default props, so the component will never receive      ex.  { myOptional: 'Hey everyone!' }
 *      that property as "undefined".
 *      In strict mode, optionals are considered part-time undefined.           ex. myOptional: string | undefined
 *      This will resolve the optional proptype as "required" under the hood,
 *      but our implementation detail will remain the same.
 *
 * @param defaultProps object with keys and values.  NOT a type definition.
 * @param Component component to apply the default props and new prop type definition to.
 */
const withDefaults = <Props extends object, DefaultProps extends Partial<Props> = Partial<Props>>(
    defaultProps: DefaultProps,
    Component: ComponentType<Props>
) => {
    type RequiredProps = Pick<Props, Exclude<keyof Props, keyof DefaultProps>>;
    type NewProps = Partial<DefaultProps> & Required<RequiredProps>;
    Component.defaultProps = defaultProps;
    return (Component as ComponentType<any>) as ComponentType<NewProps>;
};

export default withDefaults;
